import Select from 'react-select';
import { useEffect, useState } from 'react';
import { post } from '../../services/api';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import { ToastContainer, toast } from 'react-toastify';
import { TailSpin } from "react-loader-spinner";
import { ThreeDots } from "react-loader-spinner";

function GerenciamentoClusterTrv() {

    const [agrupamentoSelecionado, setAgrupamentoSelecionado] = useState([]);
    const [agrupamentoDisponivel, setAgrupamentoDisponivel] = useState([]);
    const [selectedAgrupamentoDisponivel, setSelectedAgrupamentoDisponivel] = useState([]);
    const [selectedAgrupamentoSelecionado, setSelectedAgrupamentoSelecionado] = useState([]);
    const [clusters, setClusters] = useState(null);
    const [filtroAgrupamento, setFiltroAgrupamento] = useState({ value: 1, label: 'Filial' });
    const [disabledFiltroAgrupamento, setDisabledFiltroAgrupamento] = useState(true);
    const [filtroCluster, setFiltroCluster] = useState(null);
    const [filtroMes, setFiltroMes] = useState(null);
    const [filtroAno, setFiltroAno] = useState(new Date().getFullYear());
    const [enabledGerenciamentoCluster, setEnabledGerenciamentoCluster] = useState(false);
    const [isFetchingSalvarFiliaisCluster, setIsFetchingSalvarFiliaisCluster] = useState(false);
    const [isFetchingCarregarFiliaisCluster, setIsFetchingCarregarFiliaisCluster] = useState(false);

    useEffect(() => {
        getClusters();
    }, []);

    const authToken = localStorage.getItem('adminToken');

    async function getClusters() {
        try {
           
            const response = await post('/admin/trv/clusters', {}, authToken);

            setClusters(response);
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    function cancelarCluster() {
        setAgrupamentoSelecionado([]);
        setAgrupamentoDisponivel([]);
        setSelectedAgrupamentoDisponivel([]);
        setSelectedAgrupamentoSelecionado([]);
        setEnabledGerenciamentoCluster(false);
    }

    async function salvarCluster() {

        try {
            const idUsuario = localStorage.getItem("idusuario");

            const requisicao = { mes: filtroMes.value, ano: filtroAno, cluster: filtroCluster.value, dadosAgrupamento: agrupamentoSelecionado, idusuario: idUsuario, agrupamento: filtroAgrupamento.value };

            setIsFetchingSalvarFiliaisCluster(true);

            const response = await post('/admin/trv/salvarfiliaiscluster', requisicao, authToken);

            setIsFetchingSalvarFiliaisCluster(false);

            if (!response.Sucesso) {
                toast.error(response.Mensagem);
                return;
            }

            getAgrupamentoCluster(filtroCluster, filtroMes, filtroAno, 1);
            toast.success(response.Mensagem);
        } catch (error) {
            cancelarCluster();
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    const removerAgrupamento = () => {
        const agrupamentoParaRemover = agrupamentoDisponivel.filter(agrupamento => selectedAgrupamentoDisponivel.includes(agrupamento.idagrupamento));
        setAgrupamentoSelecionado(agrupamentoSelecionado.concat(agrupamentoParaRemover));
        setAgrupamentoDisponivel(agrupamentoDisponivel.filter(agrupamento => !selectedAgrupamentoDisponivel.includes(agrupamento.idagrupamento)));
        setSelectedAgrupamentoDisponivel([]);
    };

    const adicionarAgrupamento = () => {
        const agrupamentoParaAdicionar = agrupamentoSelecionado.filter(agrupamento => selectedAgrupamentoSelecionado.includes(agrupamento.idagrupamento));
        setAgrupamentoDisponivel(agrupamentoDisponivel.concat(agrupamentoParaAdicionar));
        setAgrupamentoSelecionado(agrupamentoSelecionado.filter(agrupamento => !selectedAgrupamentoSelecionado.includes(agrupamento.idagrupamento)));
        setSelectedAgrupamentoSelecionado([]);
    }

    const handleChangeMes = (selectedOption) => {
        setFiltroMes(selectedOption);
        setFiltroAno(selectedOption.ano);
        getAgrupamentoCluster(filtroCluster, selectedOption, selectedOption.ano);
        setFiltroAgrupamento({ value: 1, label: 'Filial' });

    };

    const handleChangeCluster = (selectedOption) => {
        setFiltroCluster(selectedOption);
        getAgrupamentoCluster(selectedOption, filtroMes, filtroAno);
        setFiltroAgrupamento({ value: 1, label: 'Filial' });
    };

    const handleChangeAgrupamento = (selectedOption) => {
        setFiltroAgrupamento(selectedOption);
        getAgrupamentoCluster(filtroCluster, filtroMes, filtroAno, selectedOption.value);
    };

    async function getAgrupamentoClusterMesAnterior() {
        try {
            const requisicao = { mes: filtroMes.value, ano: filtroAno, cluster: filtroCluster.value, mesAnterior: true, agrupamento: 1 };

            setIsFetchingCarregarFiliaisCluster(true);
            
            const response = await post('/admin/trv/agrupamentocluster', requisicao, authToken);

            setIsFetchingCarregarFiliaisCluster(false);

            if (!response.agrupamentoCluster || response.agrupamentoCluster <= 0 || response.agrupamentoCluster == undefined) {
                toast.error('Não há filiais vinculadas a esse cluster no mês passado!');
            }

            setAgrupamentoSelecionado(response.agrupamentoCluster);
            setAgrupamentoDisponivel(response.agrupamentoDisponivel);
        } catch (error) {
            cancelarCluster();
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function getAgrupamentoCluster(cluster = null, mes = null, ano = null, agrupamento = 1) {
        try {
            if (cluster !== null && mes !== null && ano !== null) {
                
                const requisicao = { mes: mes.value, ano: ano, cluster: cluster.value, agrupamento: agrupamento };

                setIsFetchingCarregarFiliaisCluster(true);

                const response = await post('/admin/trv/agrupamentocluster', requisicao, authToken);

                setIsFetchingCarregarFiliaisCluster(false);

                if (response.agrupamentoCluster.length <= 0) {
                    setDisabledFiltroAgrupamento(false);
                } else {
                    setDisabledFiltroAgrupamento(true);
                    setFiltroAgrupamento({ value: 1, label: 'Filial' });
                }

                setAgrupamentoSelecionado(response.agrupamentoCluster);
                setAgrupamentoDisponivel(response.agrupamentoDisponivel);
                setEnabledGerenciamentoCluster(true);
            }
        } catch (error) {
            cancelarCluster();
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    const optionsMeses = () => {
        const currentDate = new Date()

        const optionsMes = [
            getMonth(currentDate.getMonth()),
            getMonth(currentDate.getMonth() + 1)
        ];

        return optionsMes;
    };

    function getMonth(monthIndex) {
        const nomeMeses = [
            'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
            'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
        ];

        const accurateMonthIndex = monthIndex >= 0 ? monthIndex % 12 : 12 + monthIndex % 12
        return {
            label: nomeMeses[accurateMonthIndex],
            value: (accurateMonthIndex) + 1,
            ano: new Date().getFullYear() + Math.floor(monthIndex / 12)
        };
    }

    const optionsClusters = Array.isArray(clusters) ? clusters.map((cluster) => ({
        value: cluster.idcluster,
        label: cluster.descricao,
    })) : [];

    const optionsAgrupamento = [
        { value: 1, label: 'Filial' },
        { value: 2, label: 'Região' }
    ]

    const mensagemNenhumaOpcaoAlternativa = () => 'Nenhuma opção disponível';


    return (
        <>
            <div className='form-gerencia-animal'>
                <div className='gerencia-animal-first'>
                    <div className='header'>
                        <div>
                            <span>1</span>
                            <h1>Selecione os filtros</h1>
                        </div>
                    </div>
                    <div className='animal-first-values'>
                        <div className='first-values-left'>
                            <div className='id_animal-wrapper'>
                                <label htmlFor="id_animal">Selecione o cluster</label>
                                <Select
                                    name="mes"
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    value={filtroCluster}
                                    onChange={handleChangeCluster}
                                    options={optionsClusters}
                                    isClearable={false}
                                    isSearchable={false}
                                    placeholder="Cluster"
                                    noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                                />
                            </div>
                            <div className='mes-wrapper'>
                                <label htmlFor="mes">Selecione o período</label>
                                <Select
                                    name="mes"
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    value={filtroMes}
                                    onChange={handleChangeMes}
                                    options={optionsMeses()}
                                    isClearable={false}
                                    isSearchable={false}
                                    placeholder="Mês"
                                    noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                                />
                            </div>
                            <div className='ano-wrapper'>
                                <input
                                    type='text'
                                    name='ano'
                                    placeholder='Ano'
                                    value={filtroAno}
                                    onChange={(value) => setFiltroAno(value.currentTarget.value)}
                                    required
                                    readOnly
                                />
                            </div>
                            <div className='id_animal-wrapper' style={{ width: '180px' }}>
                                <label htmlFor="id_animal">Selecione o agrupamento</label>
                                <Select
                                    name="mes"
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    value={filtroAgrupamento}
                                    onChange={handleChangeAgrupamento}
                                    options={optionsAgrupamento}
                                    isClearable={false}
                                    isSearchable={false}
                                    placeholder="Cluster"
                                    noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                                    isDisabled={disabledFiltroAgrupamento}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='gerencia-animal-second'>
                    <div className={`header ${enabledGerenciamentoCluster ? '' : 'gerenciamento-cluster-disabled'}`}>
                        <div>
                            <span>2</span>
                            <h1>Gerenciar Cluster</h1>
                        </div>

                        {isFetchingCarregarFiliaisCluster && (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <ThreeDots
                                    height="5"
                                    width="80"
                                    radius="9"
                                    color="#ff0000"
                                    ariaLabel="three-dots-loading"
                                    wrapperStyle={{}}
                                    wrapperClassName=""
                                    visible={true}
                                />
                            </div>
                        )}

                        <div className='additional-control-buttons'>
                            <button
                                className='animal-copy-values'
                                onClick={getAgrupamentoClusterMesAnterior}
                                disabled={(agrupamentoSelecionado.length > 0 || filtroAgrupamento.value == 2)}
                            >
                                <CopyAllIcon style={{ width: '25px', height: '25px', marginRight: '10px' }} />
                                Copiar cluster do mês anterior
                            </button>

                        </div>

                    </div>

                    <div className={`${enabledGerenciamentoCluster ? '' : 'gerenciamento-cluster-disabled'}`}>
                        <div className="flex justify-center items-center ">
                            <div className="flex flex-col gap-4 items-center lg:flex-row">
                                <div className="flex flex-col">
                                    <label className="mb-2 font-semibold text-lg">{(filtroAgrupamento.value == 1) ? 'Adicionar Filial' : 'Adicionar Região'}</label>
                                    <select multiple className="form-multiselect block w-80 h-64 p-2 border border-gray-300 rounded-md overflow-auto whitespace-normal"
                                        value={selectedAgrupamentoDisponivel}
                                        onChange={e => setSelectedAgrupamentoDisponivel(Array.from(e.target.selectedOptions, option => Number(option.value)))}>
                                        {Array.isArray(agrupamentoDisponivel) && agrupamentoDisponivel.map((agrupamento, index) => (
                                            <option key={index} value={agrupamento.idagrupamento}>{(filtroAgrupamento.value == 1 ? agrupamento.idagrupamento - 10000 : agrupamento.idagrupamento) + ' - ' + agrupamento.nomeagrupamento}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="flex flex-col justify-center space-y-2">
                                    <button onClick={removerAgrupamento} className="p-2 bg-blue-500 text-white rounded shadow">
                                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                                    </button>
                                    <button onClick={adicionarAgrupamento} className="p-2 bg-blue-500 text-white rounded shadow">
                                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>
                                    </button>
                                </div>

                                <div className="flex flex-col">
                                    <label className="mb-2 font-semibold text-lg">{(filtroAgrupamento.value == 1) ? 'Filiais do Cluster' : 'Regiões do Cluster'}</label>
                                    <select multiple className="form-multiselect block w-80 h-64 p-2 border border-gray-300 rounded-md overflow-auto whitespace-normal"
                                        value={selectedAgrupamentoSelecionado}
                                        onChange={e => setSelectedAgrupamentoSelecionado(Array.from(e.target.selectedOptions, option => Number(option.value)))}>
                                        {Array.isArray(agrupamentoSelecionado) && agrupamentoSelecionado.map((agrupamento, index) => (
                                            <option key={index} value={agrupamento.idagrupamento}>{(filtroAgrupamento.value == 1 ? agrupamento.idagrupamento - 10000 : agrupamento.idagrupamento) + ' - ' + agrupamento.nomeagrupamento}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className='animal-metas-buttons'>
                            <button onClick={cancelarCluster} className='animal-refresh-btn'>Cancelar</button>
                            <button onClick={salvarCluster} className='animal-save-btn'>
                                {isFetchingSalvarFiliaisCluster ? (
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <TailSpin color="#ffffff" height={20} width={39} />
                                    </div>
                                ) : (
                                    "Salvar"
                                )}

                            </button>
                        </div>
                    </div>

                </div>
                <ToastContainer />
            </div>

        </>
    )
}

export default GerenciamentoClusterTrv